const initState = {
	fetching: false,
	fetched: false,
	error: null,
	payload: {},
	saved: false,
	message: null,
	rack: {},
	isDeleted: false,
};

const rackReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RACK_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'RACK_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'RACK_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				payload: action.payload.data,
				error: null,
				saved: false,
				isDeleted: false
			};
		case 'SAVE_RACK_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'SAVE_RACK_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'SAVE_RACK_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'GET_RACK_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'GET_RACK_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'GET_RACK_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				rack: action.payload.data,
				error: null,
				saved: false,
			};
		case 'UPDATE_RACK_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'UPDATE_RACK_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'UPDATE_RACK_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'DELETE_RACK_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'DELETE_RACK_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DELETE_RACK_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				isDeleted: true
			};
		default:
			return state;
	}
};

export default rackReducer;
